/**
 * Copyright (c) 2020, 2021, 2023, 2024 Visa, Inc.
 *
 * This source code is licensed under the MIT license
 * https://github.com/visa/visa-chart-components/blob/master/LICENSE
 *
 **/
scatter-plot {
  .annotations {
    pointer-events: none;
    .handle {
      pointer-events: all;
    }
  }

  .screen-reader-info {
    position: absolute;
    left: -9999px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
  }

  .vcc-style-isolation-isolate {
    isolation: isolate;
  }

  .vcc-style-mix-blend-multiply {
    mix-blend-mode: multiply;
  }

  .vcc-style-visibility-hidden {
    visibility: hidden;
  }

  .vcc-style-display-none {
    display: none;
  }

  .vcc-style-display-block {
    display: block;
  }

  .vcc-style-point-events-none {
    pointer-events: none;
  }

  .vcc-style-cursor-pointer {
    cursor: pointer;
  }

  .vcc-style-cursor-default {
    cursor: default;
  }

  .data-table-link {
    color: #767676;
    text-decoration: none;
    font-size: 12px;
    margin-left: 5%;
  }

  .hidden {
    display: none;
  }

  .axis {
    font-size: 12px;
    text {
      font: 0.65rem;
      fill: #767676;
    }

    &-label {
      text-anchor: middle;
      font: 1rem sans-serif;
    }

    &-mark {
      path {
        color: #949494;
        stroke-width: 0px;
      }
    }

    path {
      color: #949494;
      stroke-width: 2px;
    }
  }

  .axis-mark {
    path {
      stroke: #767676;
      stroke-opacity: 1;
    }
  }

  .grid {
    line {
      stroke: #c9c9c9;
      stroke-opacity: 0.6;
      // shape-rendering: crispEdges;
      // stroke-dasharray: 4, 4;
    }

    path {
      stroke-width: 0;
      stroke: #767676;
    }
  }

  .scatter-legend {
    font-size: 1em;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    .legend {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
    }
  }
}
